import { formatBRL } from 'dashboard/helper/lais/currency';

export const createRealEstateBrokerCommissionPresenter = t => {
  const money = value =>
    formatBRL(value?.amount, {
      fallback: t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED'),
      fractionDigits: 2,
    });

  const statusLabel = detail => {
    switch (detail?.status?.slug) {
      case 'pago':
        return t('REAL_ESTATE_BROKER_COMMISSION.STATUS.RELEASED');
      case 'em_transferencia':
        return t('REAL_ESTATE_BROKER_COMMISSION.STATUS.IN_TRANSFER');
      case 'transferido':
      case 'concluido':
        return t('REAL_ESTATE_BROKER_COMMISSION.STATUS.COMPLETED');
      case 'cancelado':
        return t('REAL_ESTATE_BROKER_COMMISSION.STATUS.CANCELED');
      default:
        return t('REAL_ESTATE_BROKER_COMMISSION.STATUS.IN_PROGRESS');
    }
  };

  const address = detail => {
    const value = detail?.processo?.endereco || {};
    return (
      [value.logradouro, value.numero].filter(Boolean).join(', ') ||
      t('REAL_ESTATE_BROKER_COMMISSION.TABLE.ADDRESS_UNAVAILABLE')
    );
  };

  const addressDetail = detail =>
    [
      detail?.processo?.endereco?.unidade,
      detail?.processo?.endereco?.complemento,
      detail?.processo?.endereco?.bairro,
      detail?.processo?.endereco?.cidade,
      detail?.processo?.endereco?.uf,
    ]
      .filter(Boolean)
      .join(' · ');

  const installmentLabel = detail =>
    detail?.parcela?.modalidade === 'partes'
      ? t('REAL_ESTATE_BROKER_COMMISSION.TABLE.INSTALLMENT', {
          current: detail.parcela.numero,
          total: detail.parcela.total,
        })
      : t('REAL_ESTATE_BROKER_COMMISSION.TABLE.INTEGRAL');

  const date = value => {
    if (!value) return t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED');
    return new Intl.DateTimeFormat('pt-BR').format(new Date(value));
  };

  const roleLabel = role => {
    switch (role) {
      case 'corretores_vendedores':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.corretores_vendedores');
      case 'corretores_opcionistas':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.corretores_opcionistas');
      case 'gerentes':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.gerentes');
      case 'gerentes_gerais':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.gerentes_gerais');
      case 'diretores_gerais':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.diretores_gerais');
      case 'repasse_franquias':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.repasse_franquias');
      case 'royalties':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.royalties');
      case 'comunicacao':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.comunicacao');
      case 'empresas':
        return t('REAL_ESTATE_BROKER_COMMISSION.ROLES.empresas');
      default:
        return role || t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED');
    }
  };

  const percentage = value =>
    t('REAL_ESTATE_BROKER_COMMISSION.TABLE.PERCENTAGE', { value });

  const paymentForecast = value =>
    t('REAL_ESTATE_BROKER_COMMISSION.HERO.PAYMENT_FORECAST_VALUE', {
      date: date(value),
    });

  const methodLabel = method =>
    method?.tipo_pagamento === 'bank'
      ? t('REAL_ESTATE_BROKER_COMMISSION.PAYMENT.BANK')
      : t('REAL_ESTATE_BROKER_COMMISSION.PAYMENT.PIX');

  return {
    money,
    statusLabel,
    address,
    addressDetail,
    installmentLabel,
    date,
    roleLabel,
    methodLabel,
    percentage,
    paymentForecast,
  };
};
